import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; 
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyDUAb9aD6J5zha5dp7cl52B7BjZOgkciN0",
    authDomain: "alliedoms-qi.firebaseapp.com",
    projectId: "alliedoms-qi",
    storageBucket: "alliedoms-qi.firebasestorage.app",
    messagingSenderId: "900443677952",
    appId: "1:900443677952:web:f77745c10be992ce2a3fe5",
    measurementId: "G-TH5MXHN8FK"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

export { auth, db, storage, functions };


